// Deep-link do Check-in Diário: `?open=checkin-diario`.
//
// Duas telas precisam reconhecer o mesmo link e por motivos opostos — o layout
// pra ABRIR o modal quando ele chega na URL, e o menu horizontal pra ESCONDER o
// item que aponta pra lá quando o jogador não é elegível. Se cada lado tivesse
// sua lista, um alias novo passaria a abrir o modal por um item que o menu jura
// que não existe.

// Grafias aceitas. Canônico p/ divulgar: `checkin-diario`; as outras funcionam
// como alias por conveniência (o CMS do menu é preenchido à mão).
export const DAILY_CHECKIN_QUERY_VALUES = [
  'checkin-diario',
  'check-in-diario',
  'checkin',
];

// Valor do `?open=` da rota atual (que no Vue Router pode vir como array quando
// o parâmetro aparece repetido).
export function isDailyCheckinOpenParam(value: unknown): boolean {
  const first = Array.isArray(value) ? value[0] : value;

  return (
    typeof first === 'string' && DAILY_CHECKIN_QUERY_VALUES.includes(first)
  );
}

// O mesmo teste a partir de uma URL do CMS — relativa ('/?open=checkin-diario')
// ou absoluta. Lê o PARÂMETRO, não um pedaço da string: um link de jogo com
// 'checkin' no slug não é deep-link do check-in.
export function isDailyCheckinDeepLink(url: string): boolean {
  const start = (url || '').indexOf('?');

  if (start === -1) return false;

  // Corta o fragmento: '?open=checkin-diario#promo' tem hash depois da query.
  const query = url.slice(start + 1).split('#')[0] ?? '';

  return isDailyCheckinOpenParam(new URLSearchParams(query).get('open'));
}
